import React, { useEffect } from "react";
import { StaticImage } from "gatsby-plugin-image"
import lozad from "lozad";

// Utils
import UniversalLink from "§/src/utils/UniversalLink"
// import LazyLoad from 'react-lazyload';

// Internal
import "§/src/components/atoms/content/_tile-content-product.scss"
import "./_products.scss"

// Atoms
import ProductBadge from "§/src/components/atoms/badge/product-badge"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

// Language
import { useTranslation } from "react-i18next"

const TileContentProductAlgolia = props => {
  const { t } = useTranslation()

  const {
    uri,
    title,
    badge,
    subTitle,
    menuOrder,
    node,
    mainFeatures,
    objectID,
    _highlightResult,
    algoliaExluded,
    ...atomProps
  } = props.data
  // const formattedDate = getFormattedDate(date)

  // set atom class
  const atomClassName = "tile-content-product algolia"
  var atomClass =
    props.className != undefined
      ? atomClassName + " " + props.className
      : atomClassName


  useEffect(() => {

    const thisTile = document?.getElementById(objectID)
    const thisLi = thisTile?.parentElement

    if(badge){
      thisLi.classList.add(badge)
    }

    const { observe } = lozad('#searchresult .lozad', {
      load: function(el) {
        el.src = el.dataset.src;
        el.onload = function() {
          el.classList.add('fade')
          el.classList.add('show')
        }
      }
    })

    observe()
  }, [])


  return !algoliaExluded && (
    <div className={atomClass} {...atomProps} id={objectID}>
      <div className="tile-container">
        <div className="top">
          {badge && <ProductBadge data={badge} size="sm" />}
        </div>

        <div className="product-link">
          {node?.mediaItemUrl && (
              <img className="lozad" data-src={node?.mediaItemUrl} alt=""/>
          )}

          <div className="text-cont">
            <h4 className="title">{title}</h4>
            <div className="desc">{subTitle}</div>
          </div>

          <button className="cta btn btn-primary">{t("Scopri di più")}</button>

          <UniversalLink
            className="link-button stretched-link"
            to={uri}
          ></UniversalLink>
        </div>
      </div>
    </div>
  )
}

export default TileContentProductAlgolia
